var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms"},[_c('div',{staticClass:"container-fluid"},[_c('Navbar'),_c('div',{staticClass:"col-right",class:{'full-width':_vm.isHideNav}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }